import React from 'react';
import Modal from 'react-modal';
import css from './BackModal.module.css';
import Button from '../Button/Button';
import { useIntl } from 'react-intl';
const BackModal = ({ id, state, handleBack, handleSaveThenClose, loading }) => {
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: 'auto',
    },
  };
  const intl = useIntl();
  return (
    <div>
      <Modal
        id={id}
        isOpen={state}
        //   onAfterOpen={afterOpenModal}
        //   onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className={css.container}>
          <h2 className={css.heading}>
            {intl.formatMessage({ id: 'BackModal.BackModal.attention' })}
          </h2>
          <p>{intl.formatMessage({ id: 'BackModal.BackModal.subTitle' })}</p>
          <div className={css.buttonContainer}>
            <Button className={css.button} onClick={() => handleBack()}>
              {intl.formatMessage({ id: 'BackModal.BackModal.back' })}
            </Button>
            <Button
              type="button"
              inProgress={loading}
              className={css.button}
              onClick={() => handleSaveThenClose()}
            >
              {intl.formatMessage({ id: 'BackModal.BackModal.save' })}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default BackModal;
